import React from 'react';
import { Link } from 'react-router-dom';

import { SHARED_LEGAL_LINKS, roleLegalLinksForApp } from '../constants/legalLinks';

/**
 * Footer, including the legal links.
 *
 * Two groups, deliberately:
 *   - shared    Privacy Policy and Terms Part I — the same for everyone
 *   - this site the role annexes for the roles THIS address serves
 *
 * Terms are published as Part I plus one annex per role, so a surface must show the
 * annexes for the roles it actually serves. Showing all of them would invite someone
 * to read terms that do not bind them; showing none would mean asking people to accept
 * terms they were never offered.
 *
 * Rendered before sign-in as well as after — the legal pages have to be reachable
 * without an account.
 */
const Footer = () => {
  const roleLinks = roleLegalLinksForApp();

  return (
    <footer className="bg-white border-t border-gray-200 py-6 text-sm text-gray-600">
      <div className="container mx-auto px-4">
        <nav
          aria-label="Legal"
          className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-6"
        >
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            {SHARED_LEGAL_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="hover:text-flamingo-600 hover:underline">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          {roleLinks.length > 0 && (
            <>
              <span className="hidden h-4 w-px bg-gray-300 sm:block" aria-hidden />
              <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
                {roleLinks.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="hover:text-flamingo-600 hover:underline">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </nav>

        <p className="mt-4 text-center text-gray-500">
          &copy; {new Date().getFullYear()} Zumale Technologies LLP. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
